module.exports = __webpack_public_path__ + "static/media/tonz.86ad24ed.jpg";